import React, { useState } from 'react';
import { useBreakpoint } from '../../util/Breakpoint.context';
import { pushStateNextCompat } from '../../util/history';
// TODO: Replace Record<string, never> type with null when code has been refactored to `useQuickView` instead of directly pulling context.
export var QuickViewContext = React.createContext({});
var QuickViewProvider = function (_a) {
    var _b;
    var children = _a.children;
    var currentBreakpoints = useBreakpoint();
    var _c = useState(null), activeProductId = _c[0], setActiveProductId = _c[1];
    var _d = useState(''), previousUrl = _d[0], setPreviousUrl = _d[1];
    var _e = useState(new Map()), variant = _e[0], setVariant = _e[1];
    var _f = useState(null), handle = _f[0], setHandle = _f[1];
    var _g = useState(false), containerStylesApplied = _g[0], setContainerStylesApplied = _g[1];
    var _h = useState(null), apolloError = _h[0], setApolloError = _h[1];
    var params = new URLSearchParams();
    params.append('quickview', 'true');
    variant.forEach(function (value, key) {
        params.append(key === 'color' ? 'variant' : key, value);
    });
    var PDPLink = handle
        ? "".concat((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.origin).concat(handle, "?").concat(params)
        : '';
    /**
     * This function handles updates to the URL whenever QuickView is opened from a product card
     */
    var handleUrlUpdate = function () {
        var nextUrl = new URL(window.location.href);
        // Preserves the URL that QuickView was opened from
        // This is because replaceState is being used whenever QuickView is opened, which will be replace/update the top of the history stack every time PDP link changes
        setPreviousUrl(nextUrl);
        // This is so that pressing back button will:
        // 1. close the QuickView modal
        // 2. restore the URL to the page QuickView was opened from
        // 3. not cause a refresh upon popstate
        pushStateNextCompat(null, '', nextUrl);
    };
    return (React.createElement(QuickViewContext.Provider, { value: {
            activeProductId: activeProductId,
            apolloError: apolloError,
            containerStylesApplied: currentBreakpoints.medium
                ? containerStylesApplied
                : true,
            handle: handle,
            handleUrlUpdate: handleUrlUpdate,
            isQuickView: true,
            PDPLink: PDPLink,
            previousUrl: previousUrl,
            setActiveProductId: setActiveProductId,
            setApolloError: setApolloError,
            setContainerStylesApplied: setContainerStylesApplied,
            setHandle: setHandle,
            setVariant: setVariant,
            variant: variant
        } }, children));
};
/**
 * Custom hook for adding QuickView functionality to a component
 */
export var useQuickView = function () {
    var context = React.useContext(QuickViewContext);
    if (context === null) {
        throw new Error('useQuickView must be used within a QuickViewProvider');
    }
    return context;
};
export default QuickViewProvider;
